.countdown {
  display: flex;
  flex-wrap: wrap;
  align-items: baseline;
  gap: var(--space-2) var(--space-3);
}

.label {
  color: var(--text-muted);
  font-size: var(--text-sm);
}

/*
 * Tabular figures keep the timer from changing width as it ticks, so nothing beside it
 * shifts once a second. Brass because a countdown is board furniture, not an action.
 */
.value {
  font-size: var(--text-xl);
  font-weight: 600;
  color: var(--brass);
  font-variant-numeric: tabular-nums;
}
